<!-- <mat-form-field>
    <mat-label>Produktionsbereich auswählen</mat-label>
    <mat-select matNativeControl [(ngModel)]="selectedProductionLine" (ngModelChange)="loadWorkplaces()">
      <mat-option [value]="line.id" *ngFor="let line of productionLines">{{line.name}}</mat-option>
    </mat-select>
</mat-form-field>

<mat-form-field>
    <mat-label>Arbeitsplatz auswählen</mat-label>
    <mat-select matNativeControl [(ngModel)]="selectedWorkplace">
      <mat-option [value]="workplace.id" *ngFor="let workplace of workplaces">{{workplace.name}}</mat-option>
    </mat-select>
</mat-form-field> -->

<div class="container mt-3">
  <!-- Use Bootstrap's card styles -->
  <div class="welcome-message">
    <h3>Willkommen!</h3>
    <p>
      Bitte wählen Sie ihren Produktionsbereich/Arbeitsplatz aus, um
      fortzufahren
    </p>
    <p>
      <!-- {{ userService.user() | json }} -->
    </p>
  </div>

  <hr />
  <div class="row space-between">
    <!-- Card for Wissensdatenbank -->
    <div class="col-md-5 mt-3 mb-3">
      <div class="card">
        <div class="card-body production-line">
          <mat-list class="list-item">
            <mat-list-item class="card-text selection-title"
              >Produktionsbereich auswählen</mat-list-item
            >
            <div
              *ngFor="
                let line of productionLines;
                let i = index;
                let last = last
              "
              [ngClass]="{
                isSelected: selectedProductionLineIndex === i,
                'last-option': last
              }"
            >
              <mat-list-item
                class="select-option"
                (click)="selectProductionLine(line.id, line.name, i)"
                >{{ line.name }}</mat-list-item
              >
            </div>
          </mat-list>
        </div>
      </div>
    </div>

    <!-- Card for Stillstandsmeldung -->
    <div class="col-md-5 mt-3 mb-3">
      <div class="card">
        <div class="card-body workplace">
          <mat-list class="list-item">
            <mat-list-item class="card-text selection-title"
              >Arbeitsplatz auswählen</mat-list-item
            >
            <div
              *ngFor="
                let workplace of workplaces;
                let i = index;
                let last = last
              "
              [ngClass]="{
                isSelected: selectedWorkplaceIndex === i,
                'last-option': last
              }"
            >
              <mat-list-item
                style="cursor: pointer"
                (click)="selectWorkplace(workplace.id, workplace.name, i)"
                >{{ workplace.name }}</mat-list-item
              >
              <mat-divider></mat-divider>
            </div>
          </mat-list>
        </div>
      </div>
    </div>
  </div>
  <button class="btn btn-dark btn-lg full-width" (click)="toDashboard()">
    Weiter/Fortfahren
  </button>
</div>
